import React, { useState } from "react";
import PropTypes from "prop-types";
import api from "../../services/api";

import {
    FormContainer,
    FormHeader,
    FormField,
    Message,
    ValidationError,
    ButtonContainer,
    CancelButton,
    ConfirmButton,
} from "./KitNaoEntregueForm.styles";

const KitNaoEntregueForm = ({ gestante, gestacao, onClose, onRegistrado }) => {
    const [formValues, setFormValues] = useState({
        motivo_nao_entrega_kit: "",
        data_nao_entrega: "",
    });
    const [validationErrors, setValidationErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
        // Limpa o erro do campo ao digitar
        if (validationErrors[name]) {
            setValidationErrors((prev) => ({ ...prev, [name]: "" }));
        }
    };

    const validate = () => {
        const errors = {};
        if (!formValues.motivo_nao_entrega_kit) {
            errors.motivo_nao_entrega_kit = "A justificativa é obrigatória";
        }
        if (!formValues.data_nao_entrega) {
            errors.data_nao_entrega = "A data da não entrega é obrigatória";
        } else {
            // Validar se a data não é maior que a data atual
            const dataSelecionada = new Date(formValues.data_nao_entrega);
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);

            if (dataSelecionada > hoje) {
                errors.data_nao_entrega = "A data não pode ser maior que a data atual";
            }
        }
        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) {
            return;
        }

        setIsSubmitting(true);
        setErrorMessage("");
        setSuccessMessage("");

        try {
            // Converter a data para o formato ISO 8601 com horário
            const dataComHorario = `${formValues.data_nao_entrega}T${new Date().toTimeString().slice(0, 8)}`;

            await api.patch(
                `/gestante/${gestante.cpf}/gravidez/${gestacao.id}/nao_entrega_kit`,
                {
                    motivo_nao_entrega_kit: formValues.motivo_nao_entrega_kit,
                    data_nao_entrega_kit: dataComHorario
                }
            );


            if (onRegistrado) {
                onRegistrado();
            }

            if (onClose) {
                setTimeout(() => {
                    onClose();
                }, 1500);
            }
        } catch (error) {
            const detail =
                error.response?.data?.detail || "Erro ao registrar kit não entregue.";
            setErrorMessage(detail);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <FormContainer>
            <FormHeader>Informar Kits Não Entregues</FormHeader>
            <form onSubmit={handleSubmit}>
                <FormField>
                    <label htmlFor="data_nao_entrega">Data da Não Entrega:</label>
                    <input
                        type="date"
                        id="data_nao_entrega"
                        name="data_nao_entrega"
                        value={formValues.data_nao_entrega}
                        onChange={handleChange}
                        max={new Date().toISOString().split('T')[0]}
                    />
                    {validationErrors.data_nao_entrega && (
                        <ValidationError>{validationErrors.data_nao_entrega}</ValidationError>
                    )}
                </FormField>
                <FormField>
                    <label htmlFor="motivo_nao_entrega_kit">Justificativa:</label>
                    <select
                        id="motivo_nao_entrega_kit"
                        name="motivo_nao_entrega_kit"
                        value={formValues.motivo_nao_entrega_kit}
                        onChange={handleChange}
                    >
                        <option value="">Selecione...</option>
                        <option value="KIT_RECUSADO">Kit recusado pela gestante</option>
                        <option value="PERDA_PRAZO_ENTREGA">Perda de prazo para entrega de kit à gestante</option>
                        <option value="RESTRICAO_PERIODO_ELEITORAL">Restrição de período eleitoral</option>
                    </select>
                    {validationErrors.motivo_nao_entrega_kit && (
                        <ValidationError>{validationErrors.motivo_nao_entrega_kit}</ValidationError>
                    )}
                </FormField>



                <ButtonContainer>
                    <CancelButton type="button" onClick={onClose} disabled={isSubmitting}>
                        Cancelar
                    </CancelButton>
                    <ConfirmButton type="submit" disabled={isSubmitting}>
                        {isSubmitting ? "Enviando..." : "Enviar"}
                    </ConfirmButton>
                </ButtonContainer>
            </form>

            {successMessage && <Message>{successMessage}</Message>}
            {errorMessage && <Message isError>{errorMessage}</Message>}
        </FormContainer>
    );
};

KitNaoEntregueForm.propTypes = {
    gestante: PropTypes.object.isRequired,
    gestacao: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onRegistrado: PropTypes.func,
};

export default KitNaoEntregueForm;
